var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-useless-catch */
import { apiRequester } from '../axios';
import axios from 'axios';
import { detect } from 'detect-browser';
var browser = detect();
export * from './networkSearch';
//  ev-dev-qa.com
export var deployment = window.location.hostname.includes("evipscloud") ? "evipscloud" : "ev-dev-qa";
export * from './networkSearch';
export function fetchLogin(_a) {
    var appName = _a.appName, link = _a.link, email = _a.email, affiliationId = _a.affiliationId, staffId = _a.staffId;
    return __awaiter(this, void 0, void 0, function () {
        var windowReference, isPreOpen, response, brandCentralForm, brandCentralInput, elem, res, res, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    windowReference = null;
                    if (browser) {
                        isPreOpen = browser.name === 'safari' ||
                            browser.name === 'ios' ||
                            browser.name === 'ios-webview';
                        if (isPreOpen) {
                            windowReference = window.open();
                        }
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 10, , 11]);
                    if (!appName.includes("cloud_cma")) return [3 /*break*/, 2];
                    window.open(link + "?email=" + email, "_blank");
                    return [3 /*break*/, 9];
                case 2:
                    if (!(appName === "evinsider_dashboard---1644877138118")) return [3 /*break*/, 3];
                    window.open(link + "?email=" + email, "_blank");
                    return [3 /*break*/, 9];
                case 3:
                    if (!(appName === "brand_central")) return [3 /*break*/, 5];
                    return [4 /*yield*/, apiRequester.get("https://eva-security-service." + deployment + ".com/sso/brand-central/" + affiliationId, { withCredentials: true, })];
                case 4:
                    response = _b.sent();
                    brandCentralForm = document.createElement('FORM');
                    brandCentralForm.name = 'myForm';
                    brandCentralForm.method = 'POST';
                    brandCentralForm.action = link ? link : '';
                    brandCentralForm.setAttribute("target", "_blank");
                    brandCentralForm.setAttribute("id", "bcForm");
                    brandCentralInput = document.createElement('INPUT');
                    brandCentralInput.type = 'HIDDEN';
                    brandCentralInput.name = 'SAMLResponse';
                    brandCentralInput.value = response.data;
                    brandCentralForm.appendChild(brandCentralInput);
                    // Add the RelayState
                    brandCentralInput = document.createElement('INPUT');
                    brandCentralInput.type = 'HIDDEN';
                    brandCentralInput.name = 'RelayState';
                    brandCentralInput.value = 'Notused';
                    brandCentralForm.appendChild(brandCentralInput);
                    // Add it to the dom
                    document.body.appendChild(brandCentralForm);
                    // Click the button
                    brandCentralForm.submit();
                    elem = document.getElementById('bcForm');
                    elem === null || elem === void 0 ? void 0 : elem.remove();
                    return [3 /*break*/, 9];
                case 5:
                    if (!(appName === "adwerx")) return [3 /*break*/, 7];
                    return [4 /*yield*/, apiRequester.get("/apps/" + appName + "/login" + (staffId ? "?staffid=" + staffId : ""))];
                case 6:
                    res = _b.sent();
                    if (res.data.redirectUrl) {
                        if (windowReference) {
                            windowReference.location = res.data.redirectUrl;
                        }
                        else {
                            window.open(res.data.redirectUrl, "_blank");
                        }
                    }
                    return [2 /*return*/];
                case 7: return [4 /*yield*/, apiRequester.get("/apps/" + appName + "/login")];
                case 8:
                    res = _b.sent();
                    if (res.data.redirectUrl) {
                        if (windowReference) {
                            windowReference.location = res.data.redirectUrl;
                        }
                        else {
                            if (appName === "brand_central") {
                                window.open(res.data.redirectUrl, "_self");
                            }
                            else {
                                window.open(res.data.redirectUrl, "_blank");
                            }
                        }
                    }
                    return [2 /*return*/];
                case 9: return [3 /*break*/, 11];
                case 10:
                    error_1 = _b.sent();
                    console.log(error_1);
                    throw error_1;
                case 11: return [2 /*return*/];
            }
        });
    });
}
export function fetchProfile(numTrys) {
    if (numTrys === void 0) { numTrys = 1; }
    return __awaiter(this, void 0, void 0, function () {
        var res, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiRequester.get("/profile")];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.data];
                case 2:
                    error_2 = _a.sent();
                    if (numTrys < 3) {
                        return [2 /*return*/, fetchProfile(numTrys + 1)];
                    }
                    else {
                        console.log(error_2);
                        throw error_2;
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function fetchAffiliatons(profile) {
    return __awaiter(this, void 0, void 0, function () {
        var userId, res, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userId = profile ? profile.staffId : '';
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get("https://eva-personnel-service." + deployment + ".com/users/" + userId + "/affiliations", {
                            withCredentials: true,
                        })];
                case 2:
                    res = _a.sent();
                    return [2 /*return*/, res.data];
                case 3:
                    error_3 = _a.sent();
                    console.log(error_3);
                    return [2 /*return*/, []];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function fetchVideoViews(numTrys) {
    if (numTrys === void 0) { numTrys = 1; }
    return __awaiter(this, void 0, void 0, function () {
        var res, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiRequester.get('/me/video/view')];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.data];
                case 2:
                    error_4 = _a.sent();
                    if (numTrys < 3) {
                        return [2 /*return*/, fetchVideoViews(numTrys + 1)];
                    }
                    else {
                        console.log(error_4);
                        throw error_4;
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function postVideoView(name, numTrys) {
    if (numTrys === void 0) { numTrys = 1; }
    return __awaiter(this, void 0, void 0, function () {
        var error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiRequester.post('/me/video/view', { name: name })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_5 = _a.sent();
                    if (numTrys < 3) {
                        return [2 /*return*/, postVideoView(name, numTrys + 1)];
                    }
                    else {
                        console.log(error_5);
                        throw error_5;
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function fetchImpersonations() {
    return __awaiter(this, void 0, void 0, function () {
        var res, error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiRequester.get('/me/impersonations')];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.data];
                case 2:
                    error_6 = _a.sent();
                    return [2 /*return*/, []];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function createTicket(subject, message, fromApp) {
    return __awaiter(this, void 0, void 0, function () {
        var error_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiRequester.post('/support/tickets', {
                            subject: subject,
                            message: message,
                            fromApp: fromApp,
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_7 = _a.sent();
                    throw error_7;
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function fetchFaqs(faqName) {
    return __awaiter(this, void 0, void 0, function () {
        var res, error_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiRequester.get('/support/faq/' + faqName)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.data];
                case 2:
                    error_8 = _a.sent();
                    throw error_8;
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function fetchMyPermissions() {
    return __awaiter(this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiRequester.get('/roles/me/permissions')];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.data];
            }
        });
    });
}
export function postFeedback(subject, message, fromApp) {
    return __awaiter(this, void 0, void 0, function () {
        var error_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiRequester.post('/support/feedback', {
                            subject: subject,
                            message: message,
                            fromApp: fromApp,
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_9 = _a.sent();
                    throw error_9;
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function fetchPasswordLink() {
    return __awaiter(this, void 0, void 0, function () {
        var res, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.post('https://cms.evipscloud.com/graphql', {
                        query: "{\n        ipsIntro{\n          PasswordLink\n        }\n      }\n    ",
                    })];
                case 1:
                    res = _a.sent();
                    data = res.data.data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function fetchCmsAppData(appId) {
    return __awaiter(this, void 0, void 0, function () {
        var res, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.post('https://cms.evipscloud.com/graphql', {
                        query: "\n    query AcadamyApps {\n    worldApp(id: " + appId + ") {\n    HelpLink\n    video {\n      hlsUrl\n    }\n    videoName\n    world_app_courses {\n      Title\n      Description\n      Image {\n        alternativeText\n        url\n      }\n      Link,\n      Time\n    }\n  },\n  snowDayBanner {\n    Message,\n    Link,\n    Active\n  }\n  defaultWorldSetting {\n    defaultVideo {\n      video {\n        hlsUrl\n      }\n      videoName\n      title\n      subtitle\n    }\n  }\n}\n\n    ",
                    })];
                case 1:
                    res = _a.sent();
                    data = res.data.data;
                    return [2 /*return*/, data];
            }
        });
    });
}
